import React from 'react';
import { byCard } from 'utils';
import {
  PRODUCT_CODE_NZ_GEM,
  PRODUCT_CODE_DAVID_JONES_PRESTIGE,
  PRODUCT_CODE_DAVID_JONES_PREMIERE,
  PRODUCT_CODE_TWENTY_EIGHT_DEGREES,
  PRODUCT_CODE_GO,
} from '_config';
import { AuCardsTheme } from './AuCardsTheme';

export function BaseTheme({ children }) {
  const productTheme = () => {
    // TODO: add global style for other products
    return byCard({
      [PRODUCT_CODE_NZ_GEM]: AuCardsTheme,
      [PRODUCT_CODE_DAVID_JONES_PRESTIGE]: null,
      [PRODUCT_CODE_DAVID_JONES_PREMIERE]: null,
      [PRODUCT_CODE_TWENTY_EIGHT_DEGREES]: AuCardsTheme,
      [PRODUCT_CODE_GO]: AuCardsTheme,
      default: AuCardsTheme,
    });
  };

  const ThemeComponent = productTheme();
  if (ThemeComponent) {
    return (
      <>
        <ThemeComponent />
        {children}
      </>
    );
  }
  return children;
}
